import React from 'react';
import '../styles/Wiki.css'; // external CSS file

const Wiki = () => {
  return (
    <div className="wiki-container">
      {/* Top Section with Title and Image */}
      <div className="wiki-header">
        <h2 className="wiki-title">[Placeholder Title]</h2>
        <div className="wiki-image-placeholder">
          [Image Placeholder]
        </div>
      </div>

      {/* Compact Infobox */}
      {/* Compact Infobox */}
<div className="wiki-infobox">
  <div>
    <ul>
      <li><strong>Category:</strong> [Placeholder Category]</li>
      <li><strong>Purpose:</strong> [Placeholder Purpose]</li>
      <li><strong>Primary Focus:</strong> [Placeholder Focus]</li>
      <li><strong>Technologies:</strong> [Placeholder Technologies]</li>
    </ul>
  </div>
  <div className="wiki-image-placeholder">
    [Image Placeholder]
  </div>
</div>


      {/* Main Content */}
      <div className="wiki-content">
        <div className="wiki-section">
          <h3>[Placeholder Heading 1]</h3>
          <p>
            [This is placeholder text describing the first main topic. It will be replaced with content generated dynamically.]
          </p>
        </div>
        <div className="wiki-section">
          <h3>[Placeholder Heading 2]</h3>
          <p>
            [This is placeholder text describing the second main topic. It will be replaced with content generated dynamically.]
          </p>
        </div>
        <div className="wiki-section">
          <h3>[Placeholder Heading 3]</h3>
          <p>
            [This is placeholder text describing the third main topic. It will be replaced with content generated dynamically.]
          </p>
        </div>
        <div className="wiki-section">
          <h3>[Placeholder Heading 4]</h3>
          <p>
            [This is placeholder text describing the fourth main topic. It will be replaced with content generated dynamically.]
          </p>
        </div>
      </div>
    </div>
  );
};

export default Wiki;
